import React, { useState } from 'react';
import { Button, Input, Modal, ModalHeader } from 'reactstrap';

export const ModalInputAnimation = (props) => {
  return (
    <Modal
      id="fadeInleftModal"
      isOpen={props.isOpen}
      toggle={() => {
        props.toogle();
      }}
      modalClassName="fadeInLeft"
      centered
      autoFocus={false}
    >
      <ModalHeader>{props.title}</ModalHeader>
      <div className="modal-body">
        <form autoComplete="off" onSubmit={(e) => props.handleSubmit(e)}>
          <div className="mb-3">
            <label htmlFor="type-name" className="col-form-label">
              {props.label}
            </label>
            <Input
              autoFocus={true}
              type="text"
              className="form-control"
              id="typeName"
              placeholder={props.placeholder}
              defaultValue={props.value}
            />
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-link"
              onClick={() => {
                props.toogle();
              }}
              type="button"
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="primary" type="submit">
              {' '}
              Salvar{' '}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
